import { axiosInstance } from '../axios';

class PlannedServiceEventsService {
    async getFrontpageEvents(rangeStart, rangeEnd, onlyCurrentUserAssigned, includeLate) {
        return await axiosInstance.get(
            '/api/planned-service-events/frontpage-events',
            { params: { rangeStart, rangeEnd, onlyCurrentUserAssigned, includeLate } },
        );
    }

    async downloadFrontpageEvents(rangeStart, rangeEnd, onlyCurrentUserAssigned) {
        return await axiosInstance.get(
            '/api/planned-service-events/frontpage-events-excel-export',
            {
                responseType: 'blob',
                params: { rangeStart, rangeEnd, onlyCurrentUserAssigned },
            },
        ).then(result => {
            this._showFile(result);
        });
    }
    async downloadIcalExportSingeEvent(plannedServiceInstanceId) {

        return axiosInstance.get(
            '/api/planned-service-events/frontpage-events-ical-export-single-event',
            {
                responseType: 'blob',
                params: { plannedServiceInstanceId },
            })
            .then(result => {
                this._showFile(result);
            });
    }

    async downloadIcalExport(rangeStart, rangeEnd, onlyCurrentUserAssigned) {

        return axiosInstance.get(
            '/api/planned-service-events/frontpage-events-ical-export',
            {
                responseType: 'blob',
                params: { rangeStart, rangeEnd, onlyCurrentUserAssigned },
            })
            .then(result => {
                this._showFile(result);
            });
    }

    _showFile(result){
        const type = result.headers['content-type'];
        const blob = new Blob([result.data], { type: type });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this._getFilename(result, null);
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    _getFilename(result, fallback){
        const contentDisposition = result.headers['content-disposition'];
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch.length === 2)
                return fileNameMatch[1];
        }
        return fallback;
    }
}

export default new PlannedServiceEventsService();
